// extracted by mini-css-extract-plugin
module.exports = {"addRow":"PreferenceLocation_addRow__iYJ4m","preferenceLocation":"PreferenceLocation_preferenceLocation__c93qk"};